/**
 * Modulo que encapsula los formateadores  de fechas.
 * Tiene formatos predeterminados en función del DATEFORMATS eligido.
 *
 * Son metodos al que le pasamos luego el state y el formatFn,
 * el formatFn puede ser el normal, y el timezoned de la carpeta tz/
 */

/**
 * # Documentación
 * https://date-fns.org/v2.23.0/docs/Time-Zones
 * https://www.npmjs.com/package/date-fns-tz
 *
 * Si en Greenwich son las 13h00:
 * - En Madrid son las 15h00 (+2)
 * - En Mexico son las 8h00  (-5)
 * - En Tokyo son las 22h00 (+9)
 */
// https://www.npmjs.com/package/date-fns-tz

export const formatters = {
  /**
   * Devuelve la fecha y hora (sin segundos)
   * @param {Object} state
   * @param {Date} value el objeto `date` a formatear. La fecha debe ser localizada.
   * @param {string} dateFnsFormat el formato https://date-fns.org/v2.23.0/docs/format
   * @returns {string}
   */
  format: (state, formatFn, value, dateFnsFormat = 'PPPPpppp') => {
    return formatFn(state, value, dateFnsFormat);
  },

  /**
   * Devuelve la fecha y hora (sin segundos)
   * @param {Object} state
   * @param {Date} value el objeto `date` a formatear. La fecha debe ser localizada.
   * @returns {string}
   */
  datetime: (state, formatFn, value) => {
    return formatFn(state, value, state.dateFormat.datetime);
  },

  /**
   * Devuelve la fecha y hora (con segundos)
   * @param {Object} state
   * @param {Date} value el objeto `date` a formatear. La fecha debe ser localizada.
   * @returns {string}
   */
  datetimelong: (state, formatFn, value) => {
    return formatFn(state, value, state.dateFormat.datetimelong);
  },

  /**
   * Devuelve la fecha (sin hora)
   * @param {Object} state
   * @param {Date} value el objeto `date` a formatear. La fecha debe ser localizada.
   * @returns {string}
   */
  date: (state, formatFn, value) => {
    return formatFn(state, value, state.dateFormat.date);
  },

  /**
   * Devuelve la hora (con segundos)
   * @param {Object} state
   * @param {Date} value el objeto `date` a formatear. La fecha debe ser localizada.
   * @returns {string}
   */
  timelong: (state, formatFn, value) => {
    return formatFn(state, value, state.dateFormat.timelong);
  },

  /**
   * Devuelve la hora (sin segundos)
   * @param {Object} state
   * @param {Date} value el objeto `date` a formatear. La fecha debe ser localizada.
   * @returns {string}
   */
  time: (state, formatFn, value) => {
    return formatFn(state, value, state.dateFormat.time);
  },
};
